import { LiquidVolume, MicroliterVolume } from "../automated-pro/RnaCatalog";
// A representation of a kit received from the server.
// Doesn't have certain extras needed to support the editing UI, but should be a good fit for a r/o view.
// As in the backend, probe sets need more post processing to turn into something consumable, while we can get away
// with simpler types for detect and buffers.
var ManualProBuffersComponent = /** @class */ (function () {
    function ManualProBuffersComponent(hybridizationBuffer, ampWashBuffer, probeWashBuffer) {
        this.hybridizationBuffer = new LiquidVolume(hybridizationBuffer);
        this.ampWashBuffer = new LiquidVolume(ampWashBuffer);
        this.probeWashBuffer = new LiquidVolume(probeWashBuffer);
    }
    return ManualProBuffersComponent;
}());
export { ManualProBuffersComponent };
var ManualProKit = /** @class */ (function () {
    function ManualProKit(sampleType, probeSet, detect, buffers, chromogen, comment, negativeControlProbe, starterKit) {
        this.sampleType = sampleType;
        this.probeSet = probeSet;
        this.detect = detect;
        this.buffers = buffers;
        this.chromogen = chromogen;
        this.comment = comment;
        this.negativeControlProbe = negativeControlProbe;
        this.starterKit = starterKit;
    }
    return ManualProKit;
}());
export { ManualProKit };
var RnaFishKit = /** @class */ (function () {
    function RnaFishKit(comment, legacy, sampleType, starterKit, probeSetComponent, amplifierComponent, buffersComponent) {
        this.probeSetComponent = probeSetComponent;
        this.amplifierComponent = amplifierComponent;
        this.buffersComponent = buffersComponent;
        this.legacy = legacy;
        this.sampleType = sampleType;
        this.comment = comment;
        this.starterKit = starterKit;
    }
    return RnaFishKit;
}());
export { RnaFishKit };
var SimpleProbeSetComponent = /** @class */ (function () {
    function SimpleProbeSetComponent(probeSet, scale, index) {
        this.probeSet = probeSet;
        this.scale = scale;
        this.channel = index;
    }
    return SimpleProbeSetComponent;
}());
export { SimpleProbeSetComponent };
/**
 * scaleValue is the actual number selected by the user. Could be in pmol or uL, depending on whether its v3.0 or gold
 * pmol is used for gold probes. When a kit is gold and 2GEN, ul to pmol is no longer 1:1, so its important to note the difference
 * scaleWithUnits displays for gold, so it uses uL
 * pmolWithUnits displays for pmol, so it uses pmol
 */
var ProbeSetScale = /** @class */ (function () {
    function ProbeSetScale(scaleValue, pmol) {
        this.scaleValue = scaleValue;
        this.pmol = pmol;
        this.scaleWithUnits = scaleValue + " \u00B5L";
        if (scaleValue >= 1000) {
            this.pmolWithUnits = scaleValue / 1000 + " nmol";
        }
        else {
            this.pmolWithUnits = scaleValue + " pmol";
        }
    }
    return ProbeSetScale;
}());
export { ProbeSetScale };
var SimpleCatalogVariantProbeSet = /** @class */ (function () {
    function SimpleCatalogVariantProbeSet(customerOrganismName, customerTargetName, customerAccessionNum, customerSequence, customerProbeSetSize, organism, probeSetFamily, variant, hcrAmplifier, probeLotNumber) {
        this.customerOrganismName = customerOrganismName;
        this.customerTargetName = customerTargetName;
        this.customerAccessionNum = customerAccessionNum;
        this.customerSequence = customerSequence;
        this.customerProbeSetSize = customerProbeSetSize;
        this.organism = organism;
        this.probeSetFamily = probeSetFamily;
        this.variant = variant;
        this.hcrAmplifier = hcrAmplifier;
        this.probeLotNumber = probeLotNumber;
    }
    return SimpleCatalogVariantProbeSet;
}());
export { SimpleCatalogVariantProbeSet };
var SimpleLibraryOrganismCustomTargetProbeSet = /** @class */ (function () {
    function SimpleLibraryOrganismCustomTargetProbeSet(organism, target, hcrAmplifier, probeSetSize, probeLotNumber) {
        this.organism = organism;
        this.target = target;
        this.hcrAmplifier = hcrAmplifier;
        this.probeSetSize = probeSetSize;
        this.probeLotNumber = probeLotNumber;
    }
    return SimpleLibraryOrganismCustomTargetProbeSet;
}());
export { SimpleLibraryOrganismCustomTargetProbeSet };
var SimpleOtherOrganismCustomTargetProbeSet = /** @class */ (function () {
    function SimpleOtherOrganismCustomTargetProbeSet(organism, target, hcrAmplifier, probeSetSize, probeLotNumber) {
        this.organism = organism;
        this.target = target;
        this.hcrAmplifier = hcrAmplifier;
        this.probeSetSize = probeSetSize;
        this.probeLotNumber = probeLotNumber;
    }
    return SimpleOtherOrganismCustomTargetProbeSet;
}());
export { SimpleOtherOrganismCustomTargetProbeSet };
var ManualAmplifierComponent = /** @class */ (function () {
    function ManualAmplifierComponent(hcrAmplifier, scale, label) {
        this.hcrAmplifier = hcrAmplifier;
        this.scale = scale;
        this.label = label;
    }
    return ManualAmplifierComponent;
}());
export { ManualAmplifierComponent };
var RnaFishBuffersComponent = /** @class */ (function () {
    function RnaFishBuffersComponent(hybridization, probeWash, amplificationBuffer, amplifierWashBuffer) {
        this.hybridization = hybridization;
        this.probeWash = probeWash;
        this.ampBuffer = amplificationBuffer;
        this.ampWashBuffer = amplifierWashBuffer;
    }
    return RnaFishBuffersComponent;
}());
export { RnaFishBuffersComponent };
// Amplifier parts
// tslint:disable-next-line:max-classes-per-file
var FreeTextAmpLabel = /** @class */ (function () {
    function FreeTextAmpLabel(name) {
        this.name = "";
        this.name = name;
    }
    return FreeTextAmpLabel;
}());
export { FreeTextAmpLabel };
// 2-IHC
// tslint:disable-next-line:max-classes-per-file
var SecondaryIfKit = /** @class */ (function () {
    function SecondaryIfKit(comment, legacy, sampleType, starterKit, probe, amplifier, buffers) {
        this.sampleType = sampleType;
        this.probeComponent = probe;
        this.amplifierComponent = amplifier;
        this.buffersComponent = buffers;
        this.comment = comment;
        this.legacy = legacy;
        this.starterKit = starterKit;
    }
    return SecondaryIfKit;
}());
export { SecondaryIfKit };
// tslint:disable-next-line:max-classes-per-file
var SecondaryIfProbeComponent = /** @class */ (function () {
    function SecondaryIfProbeComponent(probe, amplifier, scale) {
        this.probe = probe;
        this.amplifier = amplifier;
        this.scale = scale;
    }
    return SecondaryIfProbeComponent;
}());
export { SecondaryIfProbeComponent };
// tslint:disable-next-line:max-classes-per-file
var SecondaryIfBuffersComponent = /** @class */ (function () {
    function SecondaryIfBuffersComponent(antibodyBuffer, antibodyWashBuffer, amplificationBuffer, goldAmpWashBuffer) {
        this.antibodyBuffer = antibodyBuffer;
        this.antibodyWashBuffer = antibodyWashBuffer;
        this.amplificationBuffer = amplificationBuffer;
        this.goldAmpWashBuffer = goldAmpWashBuffer;
    }
    return SecondaryIfBuffersComponent;
}());
export { SecondaryIfBuffersComponent };
// Encoder
// tslint:disable-next-line:max-classes-per-file
var ManualGoldIfKit = /** @class */ (function () {
    function ManualGoldIfKit(comment, sampleType, starterKit, encoderComponent, amplifierComponent, buffersComponent) {
        this.sampleType = sampleType;
        this.encoderComponent = encoderComponent;
        this.amplifierComponent = amplifierComponent;
        this.buffersComponent = buffersComponent;
        this.comment = comment;
        this.starterKit = starterKit;
    }
    return ManualGoldIfKit;
}());
export { ManualGoldIfKit };
// tslint:disable-next-line:max-classes-per-file
var EncoderComponent = /** @class */ (function () {
    function EncoderComponent(encodeA, hcrAmplifier, scale) {
        this.encodeA = encodeA;
        this.hcrAmplifier = hcrAmplifier;
        this.scale = scale;
    }
    return EncoderComponent;
}());
export { EncoderComponent };
// tslint:disable-next-line:max-classes-per-file
var ManualGoldIfBuffersComponent = /** @class */ (function () {
    function ManualGoldIfBuffersComponent(antibodyBuffer, antibodyWashBuffer, amplificationBuffer, goldAmpWashBuffer) {
        this.antibodyBuffer = antibodyBuffer;
        this.antibodyWashBuffer = antibodyWashBuffer;
        this.amplificationBuffer = amplificationBuffer;
        this.ampWashBuffer = goldAmpWashBuffer;
    }
    return ManualGoldIfBuffersComponent;
}());
export { ManualGoldIfBuffersComponent };
// Automated Gold IF
// tslint:disable-next-line:max-classes-per-file
var AutomatedGoldIfKit = /** @class */ (function () {
    function AutomatedGoldIfKit(plexity, sampleType, platform, comment, starterKit, presetScale, encoderComponent, detectComponent) {
        this.plexity = plexity;
        this.sampleType = sampleType;
        this.platform = platform;
        this.presetScale = presetScale;
        this.comment = comment;
        this.encoderComponent = encoderComponent;
        this.detectComponent = detectComponent;
        this.starterKit = starterKit;
    }
    return AutomatedGoldIfKit;
}());
export { AutomatedGoldIfKit };
// tslint:disable-next-line:max-classes-per-file
var AutomatedIfEncoderAmpPair = /** @class */ (function () {
    function AutomatedIfEncoderAmpPair(primarySpecies, hcrAmplifier, channel) {
        this.primarySpecies = primarySpecies;
        this.hcrAmplifier = hcrAmplifier;
        this.channel = channel;
    }
    return AutomatedIfEncoderAmpPair;
}());
export { AutomatedIfEncoderAmpPair };
// tslint:disable-next-line:max-classes-per-file
var AutomatedIfAmpLabelPair = /** @class */ (function () {
    function AutomatedIfAmpLabelPair(hcrAmplifier, fluorophore, channel) {
        this.hcrAmplifier = hcrAmplifier;
        this.fluorophore = fluorophore;
        this.channel = channel;
    }
    return AutomatedIfAmpLabelPair;
}());
export { AutomatedIfAmpLabelPair };
// tslint:disable-next-line:max-classes-per-file
var AutomatedIfEncoderComponent = /** @class */ (function () {
    function AutomatedIfEncoderComponent(encoderAmpPairs, encoderScaleUl, antibodyBlockMl, antibodyDiluentMl) {
        this.encoderAmpPairs = encoderAmpPairs;
        this.encoderScaleUl = encoderScaleUl;
        this.antibodyBlockMl = antibodyBlockMl;
        this.antibodyDiluentMl = antibodyDiluentMl;
    }
    return AutomatedIfEncoderComponent;
}());
export { AutomatedIfEncoderComponent };
// tslint:disable-next-line:max-classes-per-file
var AutomatedIfDetectComponent = /** @class */ (function () {
    function AutomatedIfDetectComponent(ampLabelPairs, detectAMl, detectBMl, detectCMl) {
        this.ampLabelPairs = ampLabelPairs;
        this.detectAMl = detectAMl;
        this.detectBMl = detectBMl;
        this.detectCMl = detectCMl;
    }
    return AutomatedIfDetectComponent;
}());
export { AutomatedIfDetectComponent };
// tslint:disable-next-line:max-classes-per-file
var ManualProPrice = /** @class */ (function () {
    function ManualProPrice(probeSetPriceCents, probeSetPriceCustom, detectPriceCents, detectPriceCustom, buffersPriceCents, buffersPriceCustom, chromogenPriceCents, chromogenPriceCustom) {
        this.probeSetPriceCents = probeSetPriceCents;
        this.probeSetPriceCustom = probeSetPriceCustom;
        this.detectPriceCents = detectPriceCents;
        this.detectPriceCustom = detectPriceCustom;
        this.buffersPriceCents = buffersPriceCents;
        this.buffersPriceCustom = buffersPriceCustom;
        this.chromogenPriceCents = chromogenPriceCents;
        this.chromogenPriceCustom = chromogenPriceCustom;
        this.subtotalCents = probeSetPriceCents + detectPriceCents + buffersPriceCents + chromogenPriceCents;
    }
    return ManualProPrice;
}());
export { ManualProPrice };
// tslint:disable-next-line:max-classes-per-file
var ComponentPriceInfo = /** @class */ (function () {
    function ComponentPriceInfo(priceCents, priceCustom, index) {
        this.priceCents = priceCents;
        this.priceCustom = priceCustom;
        this.index = index;
    }
    return ComponentPriceInfo;
}());
export { ComponentPriceInfo };
// tslint:disable-next-line:max-classes-per-file
var RnaFishKitPrice = /** @class */ (function () {
    function RnaFishKitPrice(probeSetPriceCents, probeSetPriceCustom, amplifierPriceCents, amplifierPriceCustom, buffersPriceCents, buffersPriceCustom, subtotalCents) {
        this.probeSetPriceCents = probeSetPriceCents;
        this.probeSetPriceCustom = probeSetPriceCustom;
        this.amplifierPriceCents = amplifierPriceCents;
        this.amplifierPriceCustom = amplifierPriceCustom;
        this.buffersPriceCents = buffersPriceCents;
        this.buffersPriceCustom = buffersPriceCustom;
        this.subtotalCents = subtotalCents;
    }
    return RnaFishKitPrice;
}());
export { RnaFishKitPrice };
// tslint:disable-next-line:max-classes-per-file
var SecondaryIfKitPrice = /** @class */ (function () {
    function SecondaryIfKitPrice(probePriceCents, probePriceCustom, amplifierPriceCents, amplifierPriceCustom, buffersPriceCents, buffersPriceCustom, subtotalCents) {
        this.probePriceCents = probePriceCents;
        this.probePriceCustom = probePriceCustom;
        this.amplifierPriceCents = amplifierPriceCents;
        this.amplifierPriceCustom = amplifierPriceCustom;
        this.buffersPriceCents = buffersPriceCents;
        this.buffersPriceCustom = buffersPriceCustom;
        this.subtotalCents = subtotalCents;
    }
    return SecondaryIfKitPrice;
}());
export { SecondaryIfKitPrice };
// tslint:disable-next-line:max-classes-per-file
var ManualGoldIfKitPrice = /** @class */ (function () {
    function ManualGoldIfKitPrice(encoderPriceCents, encoderPriceCustom, amplifierPriceCents, amplifierPriceCustom, buffersPriceCents, buffersPriceCustom, subtotalCents) {
        this.encoderPriceCents = encoderPriceCents;
        this.encoderPriceCustom = encoderPriceCustom;
        this.amplifierPriceCents = amplifierPriceCents;
        this.amplifierPriceCustom = amplifierPriceCustom;
        this.buffersPriceCents = buffersPriceCents;
        this.buffersPriceCustom = buffersPriceCustom;
        this.subtotalCents = subtotalCents;
    }
    return ManualGoldIfKitPrice;
}());
export { ManualGoldIfKitPrice };
// tslint:disable-next-line:max-classes-per-file
var AutomatedGoldIfKitPrice = /** @class */ (function () {
    function AutomatedGoldIfKitPrice(encoderPriceCents, encoderPriceCustom, detectPriceCents, detectPriceCustom, subtotalCents) {
        this.encoderPriceCents = encoderPriceCents;
        this.encoderPriceCustom = encoderPriceCustom;
        this.detectPriceCents = detectPriceCents;
        this.detectPriceCustom = detectPriceCustom;
        this.subtotalCents = subtotalCents;
    }
    return AutomatedGoldIfKitPrice;
}());
export { AutomatedGoldIfKitPrice };
// tslint:disable-next-line:max-classes-per-file
var PricedManualProKit = /** @class */ (function () {
    function PricedManualProKit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return PricedManualProKit;
}());
export { PricedManualProKit };
// tslint:disable-next-line:max-classes-per-file
var RnaFishPricedKit = /** @class */ (function () {
    function RnaFishPricedKit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return RnaFishPricedKit;
}());
export { RnaFishPricedKit };
// tslint:disable-next-line:max-classes-per-file
var SecondaryIfPricedKit = /** @class */ (function () {
    function SecondaryIfPricedKit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return SecondaryIfPricedKit;
}());
export { SecondaryIfPricedKit };
// tslint:disable-next-line:max-classes-per-file
var ManualGoldIfPricedKit = /** @class */ (function () {
    function ManualGoldIfPricedKit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return ManualGoldIfPricedKit;
}());
export { ManualGoldIfPricedKit };
// tslint:disable-next-line:max-classes-per-file
var AutomatedGoldIfPricedKit = /** @class */ (function () {
    function AutomatedGoldIfPricedKit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return AutomatedGoldIfPricedKit;
}());
export { AutomatedGoldIfPricedKit };
// tslint:disable-next-line:max-classes-per-file
var AutomatedProKit = /** @class */ (function () {
    function AutomatedProKit(comment, reasonForOther, platform, config, plexity, probeSetComponent, starterKit, detectComponent, miscComponent, chromogenComponent) {
        this.comment = comment;
        this.reasonForOther = reasonForOther;
        this.platform = platform;
        this.config = config;
        this.plexity = plexity;
        this.probeSetComponent = probeSetComponent;
        this.detectComponent = detectComponent;
        this.miscComponent = miscComponent;
        this.chromogenComponent = chromogenComponent;
        this.starterKit = starterKit;
    }
    return AutomatedProKit;
}());
export { AutomatedProKit };
// tslint:disable-next-line:max-classes-per-file
var AutomatedProProbeSetComponent = /** @class */ (function () {
    function AutomatedProProbeSetComponent(probeSet, presetScale, customScale, scale, probeHybridizationAScale, probeHybridizationBScale, index) {
        this.probeSet = probeSet;
        this.presetScale = presetScale;
        this.customScale = customScale;
        this.scale = scale;
        this.probeHybridizationAScale = probeHybridizationAScale;
        this.probeHybridizationBScale = probeHybridizationBScale;
        this.channel = index;
    }
    return AutomatedProProbeSetComponent;
}());
export { AutomatedProProbeSetComponent };
// tslint:disable:max-classes-per-file
var PretreatAScale = /** @class */ (function () {
    function PretreatAScale(scale) {
        this.volume = new MicroliterVolume(scale.volume);
        this.label = scale.label;
    }
    return PretreatAScale;
}());
export { PretreatAScale };
var PretreatBScale = /** @class */ (function () {
    function PretreatBScale(scale) {
        this.volume = new MicroliterVolume(scale.volume);
        this.label = scale.label;
    }
    return PretreatBScale;
}());
export { PretreatBScale };
var PretreatScale = /** @class */ (function () {
    function PretreatScale(scale) {
        this.volume = new MicroliterVolume(scale.volume);
        this.label = scale.label;
    }
    return PretreatScale;
}());
export { PretreatScale };
var DetectAScale = /** @class */ (function () {
    function DetectAScale(scale) {
        this.volume = new MicroliterVolume(scale.volume);
        this.label = scale.label;
    }
    return DetectAScale;
}());
export { DetectAScale };
var DetectBScale = /** @class */ (function () {
    function DetectBScale(scale) {
        this.volume = new MicroliterVolume(scale.volume);
        this.pmol = scale.pmol;
        this.concentration = scale.concentration;
        this.label = scale.label;
    }
    return DetectBScale;
}());
export { DetectBScale };
var DetectCScale = /** @class */ (function () {
    function DetectCScale(scale) {
        this.volume = new MicroliterVolume(scale.volume);
        this.label = scale.label;
    }
    return DetectCScale;
}());
export { DetectCScale };
var PostProcessAScale = /** @class */ (function () {
    function PostProcessAScale(scale) {
        this.volume = new MicroliterVolume(scale.volume);
        this.label = scale.label;
    }
    return PostProcessAScale;
}());
export { PostProcessAScale };
var PostProcessBScale = /** @class */ (function () {
    function PostProcessBScale(scale) {
        this.volume = new MicroliterVolume(scale.volume);
        this.label = scale.label;
    }
    return PostProcessBScale;
}());
export { PostProcessBScale };
var ProPreHybridizationScale = /** @class */ (function () {
    function ProPreHybridizationScale(scale) {
        this.volume = new MicroliterVolume(scale.volume);
        this.label = scale.label;
    }
    return ProPreHybridizationScale;
}());
export { ProPreHybridizationScale };
var DetectAntiHaptenScale = /** @class */ (function () {
    function DetectAntiHaptenScale(scale) {
        this.volume = new MicroliterVolume(scale.volume);
        this.label = scale.label;
    }
    return DetectAntiHaptenScale;
}());
export { DetectAntiHaptenScale };
var DetectTyramideHaptenScale = /** @class */ (function () {
    function DetectTyramideHaptenScale(scale) {
        this.volume = new MicroliterVolume(scale.volume);
        this.label = scale.label;
    }
    return DetectTyramideHaptenScale;
}());
export { DetectTyramideHaptenScale };
var DetectEnzymeApScale = /** @class */ (function () {
    function DetectEnzymeApScale(scale) {
        this.volume = new MicroliterVolume(scale.volume);
        this.label = scale.label;
    }
    return DetectEnzymeApScale;
}());
export { DetectEnzymeApScale };
var DetectEnzymeHrpScale = /** @class */ (function () {
    function DetectEnzymeHrpScale(scale) {
        this.volume = new MicroliterVolume(scale.volume);
        this.label = scale.label;
    }
    return DetectEnzymeHrpScale;
}());
export { DetectEnzymeHrpScale };
var DetectHrpQuencherScale = /** @class */ (function () {
    function DetectHrpQuencherScale(scale) {
        this.volume = new MicroliterVolume(scale.volume);
        this.label = scale.label;
    }
    return DetectHrpQuencherScale;
}());
export { DetectHrpQuencherScale };
// tslint:disable-next-line:max-classes-per-file
var ProDetectComponent = /** @class */ (function () {
    function ProDetectComponent(prefilled, presetScale, customScale, pretreatADewax, pretreatBAntigenRetrieval, pretreatBloxol, detectA, detectB, detectC, postProcessA, postProcessB, preHybridizationScale, channels) {
        this.prefilled = prefilled;
        this.presetScale = presetScale;
        this.customScale = customScale;
        this.pretreatADewax = pretreatADewax;
        this.pretreatBAntigenRetrieval = pretreatBAntigenRetrieval;
        this.pretreatBloxol = pretreatBloxol;
        this.detectA = detectA;
        this.detectB = detectB;
        this.detectC = detectC;
        this.postProcessA = postProcessA;
        this.postProcessB = postProcessB;
        this.preHybridizationScale = preHybridizationScale;
        this.channels = channels;
    }
    return ProDetectComponent;
}());
export { ProDetectComponent };
// tslint:disable-next-line:max-classes-per-file
var ProDetectChannel = /** @class */ (function () {
    function ProDetectChannel(hcrAmplifier, hapten, detectAntiHapten, detectTyramide, detectEnzymeAp, detectEnzymeHrp, detectHrpQuencher, enzyme, channel) {
        this.hcrAmplifier = hcrAmplifier;
        this.hapten = hapten;
        this.detectAntiHapten = detectAntiHapten;
        this.detectTyramide = detectTyramide;
        this.detectEnzymeAp = detectEnzymeAp;
        this.detectEnzymeHrp = detectEnzymeHrp;
        this.detectHrpQuencher = detectHrpQuencher;
        this.enzyme = enzyme;
        this.channel = channel;
    }
    return ProDetectChannel;
}());
export { ProDetectChannel };
// tslint:disable:max-classes-per-file
var ChromogenScale = /** @class */ (function () {
    function ChromogenScale(volume) {
        this.volume = volume;
    }
    return ChromogenScale;
}());
export { ChromogenScale };
var ChromogenBufferScale = /** @class */ (function () {
    function ChromogenBufferScale(volume) {
        this.volume = volume;
    }
    return ChromogenBufferScale;
}());
export { ChromogenBufferScale };
var ProHematoxylinScale = /** @class */ (function () {
    function ProHematoxylinScale(volume) {
        this.volume = volume;
    }
    return ProHematoxylinScale;
}());
export { ProHematoxylinScale };
// tslint:disable-next-line:max-classes-per-file
var ChromogenComponent = /** @class */ (function () {
    function ChromogenComponent(presetScale, customScale, chromogen, chromogenBuffer, chromogenScale, chromogenBufferScale, hematoxylinScale) {
        this.presetScale = presetScale;
        this.customScale = customScale;
        this.chromogen = chromogen;
        this.chromogenBuffer = chromogenBuffer;
        this.chromogenScale = chromogenScale;
        this.chromogenBufferScale = chromogenBufferScale;
        this.hematoxylinScale = hematoxylinScale;
    }
    return ChromogenComponent;
}());
export { ChromogenComponent };
// tslint:disable-next-line:max-classes-per-file
var AutomatedProMiscComponent = /** @class */ (function () {
    function AutomatedProMiscComponent(description, scaleInMl, scaleInSlides) {
        this.description = description;
        this.scaleInMl = new LiquidVolume(scaleInMl);
        this.scaleInSlides = scaleInSlides;
    }
    return AutomatedProMiscComponent;
}());
export { AutomatedProMiscComponent };
// tslint:disable-next-line:max-classes-per-file
var SimpleLibraryOrganism = /** @class */ (function () {
    function SimpleLibraryOrganism(id, name, scientificName) {
        this.id = id;
        this.name = name;
        this.scientificName = scientificName;
    }
    SimpleLibraryOrganism.prototype.displayName = function () {
        return this.name + " " + (this.scientificName.trim().length > 0 ? '(' + this.scientificName.trim() + ')' : '');
    };
    return SimpleLibraryOrganism;
}());
export { SimpleLibraryOrganism };
// tslint:disable-next-line:max-classes-per-file
var SimpleProbeSetFamily = /** @class */ (function () {
    function SimpleProbeSetFamily(id, geneSymbol, description, accessions) {
        this.id = id;
        this.geneSymbol = geneSymbol;
        this.description = description;
        this.accessions = accessions;
    }
    SimpleProbeSetFamily.prototype.displayName = function () {
        return this.geneSymbol + " " + (this.description.trim().length > 0 ? '(' + this.description.trim() + ')' : '');
    };
    return SimpleProbeSetFamily;
}());
export { SimpleProbeSetFamily };
// tslint:disable-next-line:max-classes-per-file
var SimpleOtherOrganism = /** @class */ (function () {
    function SimpleOtherOrganism(name) {
        this.name = name;
    }
    return SimpleOtherOrganism;
}());
export { SimpleOtherOrganism };
// tslint:disable-next-line:max-classes-per-file
var SimpleAccession = /** @class */ (function () {
    function SimpleAccession(id, accessionNum) {
        this.id = id;
        this.accessionNum = accessionNum;
    }
    return SimpleAccession;
}());
export { SimpleAccession };
// tslint:disable-next-line:max-classes-per-file
var SimpleVariant = /** @class */ (function () {
    function SimpleVariant(id, name, designNumber, targetMrnaSeq, probeSetSize, dcvScore, accession) {
        this.id = id;
        this.name = name;
        this.designNumber = designNumber;
        this.probeSetSize = probeSetSize;
        this.targetMrnaSeq = targetMrnaSeq;
        this.dcvScore = dcvScore;
        this.accession = accession;
    }
    return SimpleVariant;
}());
export { SimpleVariant };
/**
 * Ops SOP: second-generation gold-fish variants are named "2GEN#..." (with a suffix).
 * A matching variant routes to page-purified lots instead of column-purified.
 * Mirrors `isSecondGenVariantName` on the backend (kit/rnacatalog/ProbeLot.kt).
 */
export var isSecondGenVariantName = function (variantName) {
    return variantName.toUpperCase().trim().startsWith('2GEN');
};
// tslint:disable-next-line:max-classes-per-file
var CustomTarget = /** @class */ (function () {
    function CustomTarget(name, accession, targetMrnaSeq) {
        this.name = name;
        this.accession = accession;
        this.targetMrnaSeq = targetMrnaSeq;
    }
    return CustomTarget;
}());
export { CustomTarget };
// tslint:disable-next-line:max-classes-per-file
var AutomatedProPricedKit = /** @class */ (function () {
    function AutomatedProPricedKit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return AutomatedProPricedKit;
}());
export { AutomatedProPricedKit };
// tslint:disable-next-line:max-classes-per-file
var AutomatedProKitPrice = /** @class */ (function () {
    function AutomatedProKitPrice(customPrice, probeSetPriceCents, amplifierPriceCents, chromogenPriceCents, miscComponentPriceCents, subtotalCents) {
        this.customPrice = customPrice;
        this.probeSetPriceCents = probeSetPriceCents;
        this.detectPriceCents = amplifierPriceCents;
        this.chromogenPriceCents = chromogenPriceCents;
        this.miscComponentPriceCents = miscComponentPriceCents;
        this.subtotalCents = subtotalCents;
    }
    return AutomatedProKitPrice;
}());
export { AutomatedProKitPrice };
//# sourceMappingURL=KitModel.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-fish/KitModel.js
// module id = 32
// module chunks = 0